import endpoints from "../data/endpoints";
import { ChartDataRequest, ChartDataResponse } from "../types/types";
import apiRequest from "./apiRequest";

export const fetchChartData = async (
	body: ChartDataRequest,
): Promise<ChartDataResponse> => {
	return (await apiRequest(endpoints.chartData.url, {
		method: endpoints.chartData.requestMethod,
		body: JSON.stringify(body),
	})) as ChartDataResponse;
};
